export default "__VITE_ASSET__c5c02055__"